import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline } from "./_helpers";

// Tight spring physics. Drops from above, lands with a single subtle settle
// — not a cartoon bounce. The rotation amplitude is small (4°) on purpose.
export const elasticIntro: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  return {
    ...base,
    tracks: [{
      target: ROOT_TARGET,
      easing: "spring",
      delay: 0,
      keyframes: [
        { t: 0.00, opacity: 0, scale: 0.35, rotate: -8, y: -80 },
        { t: 0.45, opacity: 1, scale: 1.12, rotate:  4, y:  8 },
        { t: 0.70, scale: 0.95, rotate: -2, y: -3 },
        { t: 0.88, scale: 1.02, rotate:  1, y:  1 },
        { t: 1.00, scale: 1,    rotate:  0, y:  0 },
      ],
    }],
  };
};
